<template>
  <div>
    <v-card flat outlined shaped v-if="internalNote" min-height="150px">
      <v-card-subtitle>
        <template v-if="internalNote.Timestamp">
          <span class="font-weight-bold">{{ internalNote.Writer }}</span>
          &nbsp;
          {{
            $t("components.claims.note_item.commented_{0}", [
              formattedTimestamp,
            ])
          }}
          &nbsp;
          <span>
            {{ lines }}
          </span>
        </template>
        <template v-else>
          <span>
            {{ $t("components.claims.note_item.add_a_note") }}
          </span>
        </template>
      </v-card-subtitle>

      <v-card-text v-if="editMode">
        <v-list-item-content>
          <v-form v-model="valid">
            <quill-editor v-model="internalNote.Message" />
            <v-row>
              <v-col xs12 md4>
                <v-select
                  :value="internalNote.ClaimLines"
                  :items="claimLines"
                  :label="$t('headers.proof.claim_lines')"
                  multiple
                  :rules="[$rules.atLeastOne]"
                  class="required"
                  @change="change"
                >
                  <v-list-item slot="prepend-item" ripple @click="toggle">
                    <v-list-item-action>
                      <v-icon>
                        {{ icon() }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("components.trans-multi-select2.select_all") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider slot="prepend-item" class="mt-2" />
                  <template v-slot:selection="data">
                    {{ data.item }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item v-bind="data.attrs" v-on="data.on">
                      <v-list-item-action>
                        <v-checkbox
                          v-model="data.attrs.inputValue"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-list-item-content>
      </v-card-text>
      <v-card-text v-else-if="disabled">
        <div v-html="internalNote.Message"></div>
      </v-card-text>
      <v-card-text v-else @click="editMode = true" style="cursor:pointer">
        <span v-if="internalNote.Timestamp">
          {{ $t("components.claims.note_item.click_here_to_edit_comment") }}
        </span>
        <span v-else>
          {{ $t("components.claims.note_item.click_here_to_add_a_comment") }}
        </span>
        <div v-html="internalNote.Message"></div>
      </v-card-text>

      <v-card-actions v-if="editMode">
        <v-btn text @click="cancel">
          {{ $t("globals.cancel") }}
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid">
          {{ $t("globals.save") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="internalNote.Timestamp"
          color="error"
          @click="confirmDeleteDialog = true"
        >
          {{ $t("globals.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      scrollable
      v-model="confirmDeleteDialog"
      persistent
      max-width="400"
    >
      <material-card
        :title="$t('enums.DeleteNote')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="confirmDeleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="deleteNote">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { translate2 } from "@/trans2";
export default {
  components: {},
  props: ["note", "claimLines", "claimSubmission"],
  computed: {
    formattedTimestamp() {
      if (this.internalNote === null || this.internalNote === undefined) {
        return "";
      }
      return this.internalNote.Timestamp;
    },
    lines() {
      if (
        this.internalNote === null ||
        this.internalNote === undefined ||
        this.internalNote.ClaimLines === null ||
        this.internalNote.ClaimLines === undefined
      ) {
        return "";
      }
      const claims = [];
      // console.log(this.claimSubmission.Claims, this.internalNote.ClaimLines);
      for (let i = 0; i < this.claimSubmission.Claims.length; i++) {
        if (this.internalNote.ClaimLines.indexOf(i + 1) > -1) {
          if (this.claimSubmission.Claims[i].PlanBenefit!==null && this.claimSubmission.Claims[i].PlanBenefit!==undefined) {
            claims.push(
              translate2(
                this.claimSubmission.Claims[i].PlanBenefit.Benefit,
                "Name"
              ) +
                " (" +
                (i + 1).toString() +
                ")"
            );
          } else {
            claims.push(
                " (" +
                (i + 1).toString() +
                ")"
            );
          }
          
        }
      }
      return claims.join(", ");
    },
    disabled() {
      if (this.claimSubmission === null || this.claimSubmission === undefined) {
        return false;
      }
      if (
        this.claimSubmission.Claims === null ||
        this.claimSubmission.Claims === undefined
      ) {
        return false;
      }
      return this.note.IsMemberNote || (
        this.claimSubmission.Claims.filter(
          (o) => o.State === "PendingPayment" || o.State === "Pended"
        ).length > 0
      );
    },
  },
  data() {
    return {
      editMode: false,
      internalNote: null,
      confirmDeleteDialog: false,
      valid: false,
    };
  },
  watch: {
    note: {
      handler(v) {
        if (v) {
          this.internalNote = JSON.parse(JSON.stringify(v));
        } else {
          this.internalNote = null;
        }
        console.log(this.internalNote);
      },
    },
  },
  mounted() {
    if (this.note) {
      this.internalNote = JSON.parse(JSON.stringify(this.note));
    }
    console.log(this.internalNote);
  },
  methods: {
    cancel() {
      this.internalNote = JSON.parse(JSON.stringify(this.note));
      this.editMode = false;
    },
    save() {
      this.internalNote.Timestamp = new Date().toUTCString();
      this.$emit("save", this.internalNote);
      this.editMode = false;
    },
    deleteNote() {
      this.$emit("delete");
      this.editMode = false;
      this.confirmDeleteDialog = false;
    },
    icon() {
      if (this.allItems()) return "mdi-close-box";
      if (this.someItems()) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allItems() {
      return (
        this.internalNote.ClaimLines &&
        this.internalNote.ClaimLines.length === this.claimLines.length
      );
    },
    someItems() {
      return (
        this.internalNote.ClaimLines &&
        this.internalNote.ClaimLines.length > 0 &&
        !this.allItems()
      );
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allItems()) {
          this.change([]);
        } else {
          this.change(this.claimLines.slice());
        }
      });
    },
    change($event) {
      // console.log($event)
      let items = $event.filter((o) => o !== null && o !== undefined);
      this.internalNote.ClaimLines = items;
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped></style>
